/**
 * - None: Gives back no GetRenderTimings.
 * - Minimal: Gives back only "Complete AVERenderImage" RenderTiming in milliseconds.
 * - Full: Gives back detailed RenderTimings in milliseconds.
 */
export var RenderTiming;
(function (RenderTiming) {
    RenderTiming["None"] = "None";
    RenderTiming["Minimal"] = "Minimal";
    RenderTiming["Full"] = "Full";
})(RenderTiming || (RenderTiming = {}));
//# sourceMappingURL=render-timings.js.map